import React from 'react';
import cn from 'classnames';
import { Page } from '../page';
import { Header } from '../header';
import styles from './index.module.css';

// `noDefaultBg` forwards to Page and turns off BOTH pieces of the light app
// chrome — the near-white `.page` base colour and the pale-blue <SoftAurora>
// blob layer. Pages that paint their own backdrop (the projector surface on
// /profile) must pass it, otherwise that light chrome renders on top and
// washes any dark projector background out to a pale blue-grey.
export const ProfilePage = ({
  children,
  className,
  noHeader,
  contentClassName,
  containerClassName,
  isProfileHeader,
  mainClassName,
  noDefaultBg,
  noRegularHeader,
  userName,
  userProfileLink,
  videoBanner,
  layoutData
}) => ((
  <Page
    className={cn({ [styles.main]: true, [className]: className })}
    containerClassName={cn({ [styles.page]: true, [containerClassName]: containerClassName })}
    contentClassName={cn({ [styles.pageContent]: true, [contentClassName]: contentClassName })}
    isProfileHeader={isProfileHeader}
    noBottomBar
    noDefaultBg={noDefaultBg}
    noFixedSidebar
    noHeader={noHeader}
    noRegularHeader={noRegularHeader}
    transparentCompactHeader
    userName={userName}
    userProfileLink={userProfileLink}
    videoBanner={videoBanner}
    layoutData={layoutData}
  >
    <div className={cn({ [styles.mainContent]: true, [mainClassName]: mainClassName })}>
      {children}
    </div>
  </Page>
));
